import {React} from 'react'
import Blog from '../Components/Blog/Blog'
import Footer from '../Components/Footer/Footer'
import SubHeader from '../Components/Header/SubHeader'

function BlogPage() {
  return (
    <div>
        <SubHeader></SubHeader>
        <Blog></Blog>
        <Footer></Footer>
    </div>
  )
}

export default BlogPage